import { ref, computed, watch } from "vue";
import { getData, getItem, saveData} from '@/plugins/OdooService';
import { state, user, connection, token, organisation} from '@/plugins/authService';
import { addToCart, setCatalog, orderType, listProducts,lookupUnit } from "@/plugins/shopService";
import { openToast, showLoading, moment } from "@/plugins/interfaceControler";
import {addProduct, setXproduct,setCatalog as setCatalogItem, updateCatalog} from '@/plugins/productService';
import config from '@/config'


export const suppliers:any = ref([])
/*export const externalsssss = computed(()=>suppliers.value.filter((s:any)=>config.oci[s.website]).map((s:any)=>{
  s.oci = config.oci[s.website]
  return s
}))*/

export const externals:any = ref([])

 export async function initOCI(force=false){
      if (!organisation.value) return
      if (externals.value?.length > 0 && !force)  return false
       const configs = await getData('oci/externals',{hospital:organisation.value.id})
        externals.value = configs.map((r: any) => {
          const sup = r.supplier && r.supplier[0] ? r.supplier[0] : {}
          const params:any = {}
          r.params.map((p:any)=>params[p.key]=p.value)
          r.params = params
          return { ...r, ...sup }
        }).filter((s: any) => s)
      
 }



 initOCI()
 export async function getBase64(url:string){
  const response =  await getData('oci/base64',{url}, false)
  return response.base64
 }
async function getImage(item:any){
  const supplier = externals.value.filter((ex:any)=>ex.id==item.x_supplier_id)[0]
  
  if (!supplier || !config.oci[supplier.website]) return null
  if (config.oci[supplier.website].image) {
    //const img 
    
    item.product_image_url = await config.oci[supplier.website].image(item.barcode,item.name)//await getBase64(img)
  }
  return item.product_image_url
}

 export async function updateOCI(callback:any=null){
  
  const res = await getData('oci/cart')
  initOCI()
  res.map(async (item:any)=>{
    console.log(item)
    
    if (Number.isInteger(item.quantity / ((item.units && item.units>0) ? item.units : 1 ))) {
      item.quantity = item.quantity / ((item.units && item.units>0) ? item.units : 1 )
    } else{
      item.standard_price = item.standard_price / (item.units || 1)
      item.list_price = item.standard_price
      item.units = 1
    }
    const supplier = externals.value.filter((ex:any)=>ex.id==item.x_supplier_id)[0]
    const group = supplier ? config.oci[supplier.website].productgroup : 1376 //hack
    const res = await listProducts({
      code: item.barcode,
      supplier: item.x_supplier,
      top:1
    },false,true); //
    let p = res[0]
    
    //return console.log('gevonden', p)
    
    if (p){
      p.x_supplier_id = item.x_supplier_id
      if (p.x_article_type == 'oci' && p.x_default_code!="99999009") {
        p.x_purchase_ok = true
        p.x_sale_ok = true
       }
      if (p.x_default_code=="99999009") return false
      if (!p.x_purchase_ok) return openToast(item.name + " kan NIET worden besteld", {duration: 5000, color: 'warning'})
      if (!p.product_image_url && !p.x_image) {
        p.product_image_url = await getImage(item)
        p.x_image = p.product_image_url
        await saveData('catalog/product', {id:p.x_product_id, product_image_url: p.product_image_url})
      }
      
      
      p.source = item.x_supplier
      //p.x_ribbon = 'extern;green'
      //p.x_supplier = item.x_supplier || item.source
      //p.x_supplier_id = item.x_supplier_id || item.seller_ids
     
      //p = setXproduct(p)
      
      //p.x_article_type = 'oci'
      
      //p.x_quantity = p.quantity
      p.group = group
      p.quantity = item.quantity
      p.vta_type = null
      //p.x_list_price = item.list_price || item.lst_price
      addToCart(p)
      if (!p.x_zxl_catalog) { //update prices
        await saveData('catalog/product', {id: p.x_product_id, 
          detailed_type: 'product', 
          list_price: item.list_price || item.lst_price, 
          standard_price: item.list_price || item.lst_price,
          uom_id: p.uom_id,
          uom_po_id: p.uom_id,
          unit_of_measure_description: p.unit_of_measure_description
        })
        //end previous item
        await updateCatalog({id: p.x_hs_id,"end_date": moment().format("YYYY-MM-DD"), })
        //Create new catalog
        await setCatalogItem({
            id: p.x_product_id,
            list_price: item.list_price || item.lst_price,
            x_supplier_id:item.x_supplier_id || item.seller_ids,
            name: item.name,
            default_code: item.barcode
          }
        )
      }
      if (callback) return callback(item.name + " is toegevoegd aan uw winkelwagen")
      return openToast(item.name + " is toegevoegd aan uw winkelwagen")
    } else {
      const arr = await lookupUnit('VERP' + (item.units || 1))
    item.uom_id = arr[0] ? arr[0].id : null
    item.unit_of_measure_description = (item.units || 1) + ' stuks'
     // item.product_image_url = await getImage(item)
     item.group = group
      p = await addProduct(item,  [25], 'oci' ,'oci') //HACK Oci
      if (p.id) {
        if (!p.product_image_url) {
          p.product_image_url = await getImage(item)
          await saveData('catalog/product', {id:p.id, product_image_url: p.product_image_url})
        }
        p.source = item.x_supplier
        p.x_ribbon = 'extern;green'
        p.x_supplier = item.x_supplier || item.source
        p.x_supplier_id = item.x_supplier_id || item.seller_ids
        p.quantity = item.x_quantity || item.quantity
        //p.x_quantity = p.quantity
        p = setXproduct(p)
        
        //await saveData('oci/product', {id: item.id, detailed_type: 'consu'})
        
        addToCart(p)
        p.vta_type = null
        if (callback) return callback(item.name + " is toegevoegd aan uw winkelwagen")
        return openToast(item.name + " is aangemaakt en toegevoegd aan uw winkelwagen")
      } else if (res.message){
        return openToast(res.message)
      } else {
        return openToast("Product kan niet toegevoegd worden")
      }
      //addToCart(item)
    }
  })
 }
 
export function urlOCI(partner:any){
   const url:any = partner.oci_url
  const params:any = partner.params
  params.HOOK_URL = escape(config.oci.hook_url + partner.source + '/' + partner.id + '?x-api-key=' + connection.value.key + '&token=' + token.value + '&source=' + partner.name + '&redir=' + document.location.origin + config.oci.callback)
  const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
 return url + '?' + queryString
}

 export async function addExternal(partner:any, ){
      if (!partner.oci) return addExternalSupplier(partner)
      const valid = setCatalog()
      if (!valid) return openToast('U kunt geen OCI bestelling toevoegen aan een ' + orderType.value + ' bestelling', {duration: 5000, color: 'warning'})
      showLoading('Openen van de bestelpagina van ' + partner.name,10000)
      //window.open('https://www.technischeunie.nl/redirect/erpRedirect.jsp?password=vfl7AmG&user=OCI%2F1428044&disposalcontrib=true&SAPOCITYPE=FRM&HOOK_URL=https%3a%2f%2fzorgservicexl-prelive.sanastores.net%2foci%2fsubmit%3ftype%3dtechniek%26sessionid%3dc5209b94-de1a-4f4b-b77f-953fc0de75ba&kostensoort=&requestid=691395&VENDOR=0000401577&CUSTFIELD4=VAR%3AVATPCT&LEADTIME=DEFAULT')
      const url:any = partner.oci.url
      const params:any = partner.oci.params
      params.HOOK_URL = escape(params.HOOK_URL + partner.id + '?x-api-key=' + connection.value.key + '&token=' + token.value + '&source=' + partner.name + '&redir=' + document.location.origin + config.oci.callback)
      const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
      //return console.log(url + '?' +queryString)
      document.location = url + '?' + queryString
 }

 export async function addExternalSupplier(partner:any, ){
    const valid = setCatalog()
  if (!valid) return openToast('U kunt geen OCI bestelling toevoegen aan een ' + orderType.value + ' bestelling', {duration: 5000, color: 'warning'})
  showLoading('Openen van de bestelpagina van ' + partner.name,10000)
  //window.open('https://www.technischeunie.nl/redirect/erpRedirect.jsp?password=vfl7AmG&user=OCI%2F1428044&disposalcontrib=true&SAPOCITYPE=FRM&HOOK_URL=https%3a%2f%2fzorgservicexl-prelive.sanastores.net%2foci%2fsubmit%3ftype%3dtechniek%26sessionid%3dc5209b94-de1a-4f4b-b77f-953fc0de75ba&kostensoort=&requestid=691395&VENDOR=0000401577&CUSTFIELD4=VAR%3AVATPCT&LEADTIME=DEFAULT')
  
  const url:any = partner.oci_url
  const params:any = partner.params
  params.HOOK_URL = escape(config.oci.hook_url + partner.source + '/' + partner.id + '?x-api-key=' + connection.value.key + '&token=' + token.value + '&source=' + partner.name + '&redir=' + document.location.origin + config.oci.callback)
  const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  //console.log(partner,queryString)
  //return console.log(url + '?' + queryString)
  document.location = url + '?' + queryString
}


